export default "__VITE_ASSET__Be8gP9pV__"